import { HighDensityComponent } from './high-density.component';
import { Routes } from '@angular/router';

export const HIGH_DENSITY_ROUTES: Routes = [{
    path: 'high-density',
    component: HighDensityComponent
}];
